import alert from '@/utils/alert'
import formatter from '@/utils/formatter'

export default {
	install: (Vue) => {		
		Vue.prototype.$alert = alert
		Vue.prototype.$format = formatter
	}
}
